import React, { useContext, useEffect, useState, useMemo } from "react";
import { Button, Modal } from 'react-bootstrap';
import { toast } from "react-toastify";
import http from "../Services/httpService";
import services from "../Services/noronServices";

export default function UserAccount({ show, handleClose, devices, data }) {
  const [form, setForm] = useState(services.defaultUserAccount);
  useEffect(() => {
    setForm({ ...data });
  }, [data])

  

  const [isDoPosting, setIsDoPosting] = useState(false)
  const handleDo = async (e) => {
    setIsDoPosting(true);
    await services.UserAccountPost(form)
      .then(({ data }) => {
        setIsDoPosting(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        toast.dark('ثبت شد');
        handleClose(e);
        //setList(data.payload);
      })
      .catch(err => {
        setIsDoPosting(false);
      });
  }


  return (
    <>
      <Modal show={show} onHide={handleClose} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title className="">کاربر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-3">
            <div className="col">
              <div className="form-floating  mb-3">
                <input
                  className="form-control"
                  name="mobile"
                  value={form.mobile}
                  onChange={e => http.handleChange(e, form, setForm)}
                  type="number"
                  disabled={form.subUserId!=0}
                />
                <label >شماره همراه   </label>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <div className="form-floating  mb-3">
                <input
                  className="form-control"
                  name="displayName"
                  value={form.displayName}
                  onChange={e => http.handleChange(e, form, setForm)}
                  type="text"
                  disabled={form.subUserId!=0}
                />
                <label >نام   </label>
              </div>
            </div>
          </div>
{/*
          <div className="row mt-3">
            <div className="col">
              <div className="form-floating  mb-3">
                <input
                  className="form-control"
                  name="nationalCode"
                  value={form.nationalCode}
                  onChange={e => http.handleChange(e, form, setForm)}
                  type="number"
                  disabled={form.subUserId!=0 && 1==2}
                />
                <label >کد ملی   </label>
              </div>
            </div>
          </div>
  */}
          <div className="row mt-3">
            <div className="col">
              <label >دستگاه های قابل دسترس   </label>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col overflow-y-scroll" style={{height:"150px", overflowY:"auto"}}>
              {devices && devices.map((item, index) =>
                <div className="row border-bottom rounded p-3" key={index + "accountUser"}>
                  <div className="col-auto">
                    <div className="form-check">
                      <input className="form-check-input"
                        type="checkbox"
                        value=""
                        checked={  form.devices.find(x => x == item.id)!=undefined} 
                        onChange={(e) => {
                          let temp = [...form.devices];
                          temp = temp.filter(x => x != item.id)
                          setForm({ ...form, devices: e.target.checked ? [...temp, item.id] : [...temp] });
                        }}
                        id="flexCheckDefault" />
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        {item.deviceName}
                      </label>
                    </div>
                  </div>                  
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" className="col btn btn-success btn-block myCustomButton"
            onClick={handleDo}
            disabled={isDoPosting}>
            {isDoPosting &&
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            }
            <span>&nbsp;&nbsp;&nbsp;تایید </span>
          </Button>
          <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
            onClick={handleClose}>
            <span>&nbsp;&nbsp;&nbsp;انصراف</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

